import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const downloadReport = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  apiClient.get<any, ApiClientResponse<any>>(routes.activities.report(id), {
    responseType: 'blob',
  });
